import { Box } from '@mui/material';
import { withTheme } from '@mui/styles';
import styled from 'styled-components';

export const HeadingCpdDetail = withTheme(styled(Box)`
  background: linear-gradient(92.76deg, #538d87 24.56%, #164843 93.61%);
  .MuiBreadcrumbs-separator {
    svg {
      fill: white;
    }
  }
`);

export const ImageBox = withTheme(styled(Box)`
  position: relative;
  width: 462px;
  height: 274px;
  img {
    border-radius: 20px;
  }
  ${(props: any) => props.theme.breakpoints.down('lg')} {
    width: 100%;
    height: 0;
    padding-bottom: 58%;
    margin-bottom: 1rem;
  }
  ${(props: any) => props.theme.breakpoints.down('md')} {
    margin-bottom: 0.5rem;
  }
`);

export const DetailBox = withTheme(styled(Box)`
  position: relative;
  min-height: 274px;
  max-height: 400px;
  display: flex;
  flex-direction: column;
  height: 100%;
  ${(props: any) => props.theme.breakpoints.down('lg')} {
    .train {
      margin: 2rem 0 1rem 0;
    }
  }
  ${(props: any) => props.theme.breakpoints.down('md')} {
    .train {
      margin: 1rem 0;
    }
    height: 329px;
  }
`);

export const TrainBox = withTheme(styled(Box)`
  display: grid;
  grid-template-columns: 100% 1fr;
  grid-gap: 1rem;
  width: 100%;
`);
